import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Color, Orientation, Icons } from '@lsq-frontend/common-ui';

@Component({
    selector: 'admin-buyer-configuration-paid-transfer-fees',
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Buyer Paid Transfer Fees"
            sectionFormControlName="buyerPaidEarlyPaymentTransferFeesEnabled"
            [sectionFormGroup]="buyerPaidEarlyPaymentTransferFeesFormGroup"
        >
            <form
                [formGroup]="buyerPaidEarlyPaymentTransferFeesFormGroup"
                [style.padding]="'2rem 3rem'"
            >
                <div class="row">
                    <div class="col-12" [style.marginBottom]="'1.8rem'">
                        <div class="text-bold">Buyer Paid Transfer Fees*</div>
                        <p>
                            Set an override of the buyer account-level settings for this fee type.
                        </p>
                    </div>
                    <div class="col-12" [style.marginBottom]="'1rem'">
                        <lsq-switch
                            containerClass="flex-left-to-right"
                            [labelOrientation]="orientation.Right"
                            [labelTemplateRef]="buyerPaidEarlyPaymentTransferFeesLabelTemplate"
                            labelClass="text-bold"
                            [id]="'buyerPaidEarlyPaymentTransferFeesActive'"
                            [name]="'buyerPaidEarlyPaymentTransferFeesActive'"
                            [formControlName]="'buyerPaidEarlyPaymentTransferFeesActive'"
                            [group]="buyerPaidEarlyPaymentTransferFeesFormGroup"
                        ></lsq-switch>
                        <ng-template #buyerPaidEarlyPaymentTransferFeesLabelTemplate>
                            <lsq-label
                                [label]="'Buyer Paid'"
                                [subLabel]="
                                    'The buyer is responsible for paying all early payment transfer fees.'
                                "
                            ></lsq-label>
                        </ng-template>
                    </div>
                </div>
            </form>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationPaidTransferFeesComponent {
    @Input() public buyerPaidEarlyPaymentTransferFeesFormGroup: FormGroup;
    @Input() public hasClickedSave: boolean;

    public readonly icons = Icons;
    public readonly color = Color;
    public readonly orientation = Orientation;
}
